import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import CookieBanner from '../../components/feature/CookieBanner';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import SeoArticleSection from './components/SeoArticleSection';
import LocationSection from './components/LocationSection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'İzmir Vize Danışmanlık | Hızlı ve Güvenilir Hizmet';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <SeoArticleSection />
        <LocationSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
};

export default HomePage;
